import React from 'react'

function Heading() {
  return (
    <div className='container'>
      <h1 className='mt-4 ms-4 fs-5 fw-bolder text-dark '> Categories </h1>
    </div>
  )
}

export default Heading
